import { BackHandler, Platform } from 'react-native'
import api from './api'
import wait from '../lib/wait'
import { downloadFiles, deleteFiles } from '../redux/files'
import { setTotalPages } from '../redux/help'
import { changeGameState, changeFinishTime, reset } from '../redux/game'
import { deviceConnectionUpdate, unregister, checkIfEventClosed, deviceStatusChecked } from '../redux/device'
import { registerTeamSuccess, registerTeamError } from '../redux/team'
import { setQuestionsReset } from '../redux/survey'
import * as businesses from '../redux/businesses'
import * as financials from '../redux/financials'
import * as treasury from '../redux/treasury'
import * as summaries from '../redux/summary'
import { setCEOTransferRequestReceived, checkCeoTransferPending } from '../redux/participants'

import NavigationService from './navigation'
import Automator from './automator'

const SECONDS_IN_A_DAY = 86400

const getFinishTime = (finishTime, currentServerTime) => {
  if (finishTime) {
    const nowVal = new Date().valueOf()
    const serverTime = new Date(currentServerTime).valueOf()
    const diffSeconds = (serverTime - nowVal) / 1000
    if (Math.abs(diffSeconds) > 1 && Math.abs(diffSeconds) < SECONDS_IN_A_DAY) {
      const d = new Date(finishTime)
      d.setSeconds(d.getSeconds() - diffSeconds)
      finishTime = d.toISOString()
    }
  }
  return finishTime
}
export default class HeartBeater {
  constructor (store) {
    this.store = store
    this.working = false
    this.automator = new Automator(store)
  }

  start () {
    this.working = true
    this.doHeartbeat()
  }

  doHeartbeat = async () => {
    const { device: deviceState, team: teamState, game: gameState, help: helpState } = this.store.getState()
    if (this.working && deviceState.registered && (!deviceState.participantDetails || (deviceState.participantDetails && !deviceState.participantDetails.eventClosed))) {
      try {
        const response = await api.getDeviceStatus(deviceState.deviceId)
        if (response.status === 'shutdown' && Platform.OS === 'android') {
          this.store.dispatch(deleteFiles())
          setTimeout(() => {
            this.working = false
            BackHandler.exitApp()
          }, 1000)
          return this.store.dispatch(reset())
        }
        if (!deviceState.deviceStatusChecked) {
          this.store.dispatch(deviceStatusChecked())
        }
        if (gameState.gameId && gameState.gameId !== response.gameId) {
          this.store.dispatch(deleteFiles())
          this.store.dispatch(reset())
        }
        this.store.dispatch(changeGameState(response))
        if (response.team && teamState.name !== response.team.name) {
          this.store.dispatch(registerTeamSuccess(response.team))
        }
        if (!response.team && teamState.name) {
          this.store.dispatch(registerTeamError(null))
        }
        if (!deviceState.connected) {
          this.store.dispatch(deviceConnectionUpdate(true))
        }
        const finishTime = getFinishTime(response.finishTime, response.currentTime)
        if (deviceState.finishTime !== finishTime) {
          this.store.dispatch(changeFinishTime(finishTime))
        }
        if (response.numberOfHelpFiles !== helpState.totalPages) {
          this.store.dispatch(setTotalPages(response.numberOfHelpFiles))
        }
        if (gameState.currentRound !== response.currentRound) {
          this.store.dispatch(businesses.updatePage(0))
          this.store.dispatch(financials.updatePage(0))
          this.store.dispatch(treasury.updatePage(0))
          this.store.dispatch(summaries.updatePage(0))
          NavigationService.navigate('Summary')
        }
        this.store.dispatch(setQuestionsReset(response.surveyQuestionsReset))
        this.store.dispatch(downloadFiles(response.filesToDownload))
        this.store.dispatch(setCEOTransferRequestReceived(response.ceoTransferRequest))
        this.store.dispatch(checkCeoTransferPending(response.ceoTransferRequestPending))

        this.automator.start(response.automate)
      } catch (err) {
        if (!deviceState.deviceStatusChecked) {
          this.store.dispatch(deviceStatusChecked())
        }
        if (err.message === 'This device is not registered yet') {
          this.store.dispatch(unregister())
          this.store.dispatch(deleteFiles())
          this.store.dispatch(reset())
        }
        if (deviceState.connected) {
          this.store.dispatch(deviceConnectionUpdate(false))
        }
        this.store.dispatch(checkIfEventClosed())
        // this.automator.stop()
      }
    }
    await wait(10000)
    this.doHeartbeat()
  }
}
